<template>
  <div style="min-height:70vh;padding:10px">
    <Form :model="searchData" inline :label-width="100">
      <FormItem label="级别">
        <Select @on-change="getData(1)" v-model="searchData.grade_id" clearable style="width: 200px">
          <Option v-for="(i, n) in gradeList" :value="i.id" :key="n">{{
            i.name
          }}</Option>
        </Select>
      </FormItem>
      <FormItem label="科目">
        <Select @on-change="getData(1)" v-model="searchData.subject_id" clearable style="width: 200px">
          <Option v-for="(i, n) in subjectList" :value="i.id" :key="n">{{
            i.name
          }}</Option>
        </Select>
      </FormItem>
      <FormItem label="课程">
        <Select @on-change="getData(1)" v-model="searchData.course_id" clearable style="width: 200px">
          <Option v-for="(i, n) in curseList" :value="i.id" :key="n">{{
            i.name
          }}</Option>
        </Select>
      </FormItem>
    </Form>
    <div style="text-align:right;margin-bottom:10px"><Button size="small" @click="$router.go(-1)">返回</Button></div>
    <Table :columns="tableColumns" :data="tableData.data" :loading="tableLoading" border style="margin:10px 0;">
      <template slot-scope="{ row }" slot="action">
        <Button type="primary" v-if="row.is_practice == 0 || row.is_practice == 3" size="small"
          @click="$router.push('/examinationBank/paperLibraryExes?id=' + row.id + '&name=' + row.name)">开始练习</Button>
        <Button type="warning" v-if="row.is_practice == 1" size="small"
          @click="$router.push('/examinationBank/paperLibraryExes?id=' + row.id + '&name=' + row.name)">继续模考</Button>
        <Button type="warning" v-if="row.is_practice == 2" size="small" @click="addCourse(row)">成绩报告</Button>
        <Button type="info" v-if="row.is_practice == 2" size="small"
          @click="$router.push('/examinationBank/paperLibraryExes?id=' + row.id + '&name=' + row.name)">再来一次</Button>
        <Button type="info" size="small"
          @click="$router.push('/examinationBank/paperLooks?id=' + row.id + '&name=' + row.name)">试卷解析</Button>
      </template>
    </Table>
    <Page style="text-align:right" :total="tableData.total" :page-size="tableData.per_page"
      :current="tableData.current_page" show-total @on-change="getData" />
  </div>
</template>
<script>
  import { mapState } from "vuex";
  import indexPage from "../../mixins/indexPage";
  export default {
    computed: {
      ...mapState({
        gradeList(state) {
          return state.global.gradeList;
        },
        subjectList(state) {
          return state.global.subjectList;
        },
        curseList(state) {
          return state.global.curseList;
        },
      }),
    },
    data() {
      return {
        searchData: {},
        tableColumns: [
          { title: "ID", key: "id", align: "center", maxWidth: 80 },
          { title: "试卷名称", key: "name", minWidth: 50, align: "center" },
          { title: "模拟次数", key: "number", align: "center" },
          {
            title: '所属级别',
            key: 'grade_name',
            align: 'center',
            minWidth: 120,
          },
          {
            title: '所属科目',
            key: 'subject_name',
            align: 'center', minWidth: 120,
          },
          {
            title: '所属课程',
            key: 'course_name',
            align: 'center', minWidth: 120,
          },
          { title: "最近一次分值", key: "get_score", align: "center", minWidth: 120, },
          { title: "操作", slot: "action", minWidth: 200, align: "center" },
        ],
        indexUrl: "/app/source_exam_paper/index",
      };
    },
    mounted() {
      this.searchData.storage_id = this.$route.query.id
      // this.getData(1)
    },
    activated() {
      // 初始化筛选列表
      this.$store.dispatch("global/getAllSelect");
      this.searchData.storage_id = this.$route.query.id
      this.getData(1)
    },
    mixins: [indexPage],

    methods: {
      addCourse(row) {
        console.log(row)
        this.$router.push({ path: 'examinationBank/historyDetail', query: { id: row.id, type: row.type, is_free: row.is_free } })
      },
    }
  };
</script>
<style scoped>
  .group-name:nth-child(n + 2)::before {
    content: " / ";
  }
</style>
